<template>
  <div class="container">
    <div class="fixed-cards">
      <!-- 商户报单详情的表单 -->
      <el-card shadow="hover" class="card">
        <div slot="header" class="clearfix">
          <span>商户报单信息:</span>
        </div>
        <div class="card-content">
          <el-row>
            <el-col :span="8"><strong>客户姓名:</strong> {{ info.customName }}</el-col>
            <el-col :span="8"><strong>客户手机号:</strong> {{ info.customMobile }}</el-col>
            <el-col :span="8"><strong>客户地址:</strong> {{ info.customAddress }}</el-col>
          </el-row>
          <!-- 店铺信息：shopName、shopAddress、shopMobile -->
          <el-row>
            <el-col :span="8"><strong>店铺名称:</strong> {{ info.shopName }}</el-col>
            <el-col :span="8"><strong>店铺电话:</strong> {{ info.shopMobile }}</el-col>
            <el-col :span="8"><strong>店铺地址:</strong> {{ info.shopAddress }}</el-col>
          </el-row>
          <el-row>
            <el-col :span="8"><strong>其他产品:</strong> {{ info.otherProducts.join(", ") }}</el-col>
            <el-col :span="8"><strong>锅炉品牌:</strong> {{ info.boilerBrand }}</el-col>
            <el-col :span="8"><strong>供应方式:</strong> {{ info.supplyMode }}</el-col>
            <el-col :span="8"><strong>组数:</strong> {{ info.numberGroups }}</el-col>
            <el-col :span="8"><strong>附加选项:</strong> {{ info.additionalOptions.join(", ") }}</el-col>
          </el-row>
          <el-row>
            <el-col :span="8"><strong>备注:</strong> {{ info.remarks }}</el-col>
          </el-row>
        </div>
      </el-card>
    </div>
    <div class="fixed-cards">
      <el-card shadow="hover" class="card">
        <div slot="header" class="clearfix">
          <span>附件备注信息:</span>
        </div>
        <ImageUpload action="#" :multiple="true" :inTable="true" :limit="9" @uploaded="handleUploaded"
          :uploaded-images="info.attachmentUrl" />
      </el-card>
    </div>

    <div class="fixed-cards">
      <!-- 项目选择表格 -->
      <el-card shadow="hover" class="card">
        <div slot="header" class="clearfix">
          <span>项目列表:</span>
        </div>
        <div class="card-content">
          <el-table :data="selectedGoods" style="width: 100%" border>
            <el-table-column prop="name" label="项目名称">
            </el-table-column>
            <el-table-column label="查看项目工单" align="center"
              v-if="selectedGoods.map(g => g.childGoods).flat().length > 0">
              <template slot-scope="scope">
                <div v-if="scope.row.childGoods" style="display: flex;">
                  <el-button v-for="(product, index) in scope.row.childGoods" :key="index" size="mini"
                    @click="viewWorkOrder(product)" type="success" icon="el-icon-view">
                    {{ product.name }}
                  </el-button>
                </div>
              </template>
            </el-table-column>

          </el-table>
        </div>
        <!-- 提交和返回按钮 -->
        <div class="fixed-cards">
          <div class="card-content" style="text-align: center;">
            <el-button type="danger" size="small" @click="goBack" icon="el-icon-circle-close-outline">返回</el-button>
          </div>
        </div>
      </el-card>
    </div>
  </div>
</template>

<script>
import { getMerchantOrder } from "@/api/work/engineeringProject/merchants";
import { findPureWaterGoodsByRootDepartId, findEngineeringGoods } from "@/api/salesCloud/goodsQr";
import { resolveUrlPath } from "@/util/util";
import ImageUpload from "./components/videoAndFileUpload/videoAndFileUpload.vue";
export default {
  components: {
    ImageUpload,
  },
  data() {
    return {
      goodsList: [], // 项目列表
      selectedGoods: [], // 用户选择的项目
      otherProductsOptions: [
        {
          value: "蘑菇板湿法日丰地暖",
          label: "蘑菇板湿法日丰地暖"
        },
        {
          value: "铝板干法日丰地暖",
          label: "铝板干法日丰地暖"
        },
        {
          value: "电地暖：合金丝发热线",
          label: "电地暖：合金丝发热线"
        },
        {
          value: "电地暖：发热膜",
          label: "电地暖：发热膜"
        },
        {
          value: "电地暖：碳纤维",
          label: "电地暖：碳纤维"
        },
        {
          value: "小管距地暖",
          label: "小管距地暖"
        },
        {
          value: "新风系统",
          label: "新风系统"
        },
        {
          value: "中央热水",
          label: "中央热水"
        },
        {
          value: "两联供",
          label: "两联供"
        },
        {
          value: "五恒系统",
          label: "五恒系统"
        }
      ],
      supplyModeOptions: [
        {
          value: "日丰地暖成都营销中心提供",
          label: "日丰地暖成都营销中心提供"
        },
        {
          value: "甲供乙安",
          label: "甲供乙安"
        },
        {
          value: "甲供甲安",
          label: "甲供甲安"
        }
      ],
      additionalOptionsOptions: [
        {
          value: "生活热水循环泵",
          label: "生活热水循环泵"
        },
        {
          value: "外置生活热水储水罐",
          label: "外置生活热水储水罐"
        }
      ],
      info: {
        contactName: "",
        contactMobile: "",
        customAddress: "",
        otherProducts: "",
        boilerBrand: "",
        supplyMode: "",
        numberGroups: "",
        additionalOptions: "",
        remarks: "",
      }, // 表单数据
      isFormReadOnly: true, // 整个表单是否只读
    };
  },
  created() {
    const id = this.$route.query.id;

    if (id) {
      getMerchantOrder(id).then(res => {
        if (res.code === "200") {
          const data = JSON.parse(res.data).rows[0];
          // console.log('data::: ', data);
          this.info = data;
          this.info.attachmentUrl = data.attachmentUrl || [];  // 确保 attachmentUrl 存在并赋值
          this.info.otherProducts = data.otherProducts ? data.otherProducts.split(",") : [];
          this.info.supplyMode = data.supplyMode || "";
          this.info.additionalOptions = data.additionalOptions ? data.additionalOptions.split(",") : [];
          this.findPureWaterGoodsByRootDepartId(data.list);
        } else {
          this.$message({
            showClose: true,
            message: res.message,
            type: "error"
          });
        }
      });
    }
  },
  methods: {
    handleUploaded(urls) {
      this.info.attachmentUrl = urls;
    },
    // 处理安装时间变更
    handleInstallTimeChange(value) {
      if (value) {
        const timestamp = new Date(value).getTime(); // 将日期转换为时间戳
        this.info.installTime = timestamp;
      } else {
        this.info.installTime = null; // 如果没有选择时间，则设置为null
      }
    },
    // 获取项目列表
    findPureWaterGoodsByRootDepartId(selectedGoods) {
      const type = 'ENGINEERING';
      findPureWaterGoodsByRootDepartId(type).then(async (res) => {
        if (res.code === "200") {
          const data = JSON.parse(res.data);
          this.goodsList = data || [];
          this.selectedGoods = await Promise.all(
            selectedGoods.map(async (item) => ({
              goodsId: item.goodsId,
              num: item.num,
              declarationId: item.declarationId,
              name: this.goodsList.find(g => g.id === item.goodsId) ? this.goodsList.find(g => g.id === item.goodsId).name : "",
              childGoods: await this.getChildGoodsById(item.goodsId, item.serviceOrderId ? item.serviceOrderId : []),
            }))
          );
          // console.log('this.selectedGoods:::1 ', this.selectedGoods);

        } else {
          this.$message({
            showClose: true,
            message: res.message,
            type: "error"
          });
        }
      });
    },
    // 获取子产品信息
    async getChildGoodsById(id, servicesOrderIdAndGoodsId) {
      // 解析字符串为对象数组
      const servicesOrderMap = {};
      if (servicesOrderIdAndGoodsId.length > 0) {
        servicesOrderIdAndGoodsId.split(',').forEach(item => {
          const [serviceOrderId, goodsId] = item.split(':');
          servicesOrderMap[goodsId] = serviceOrderId; // 将商品ID与工单ID关联
        });
      }

      const response = await findEngineeringGoods(id);
      if (response.code === "200") {
        const data = JSON.parse(response.data).rows;
        const childGoods = [];

        for (const item of data) {
          for (const subItem of item.list) {
            const serviceOrderId = servicesOrderMap[subItem.id]; // 根据商品ID查找工单ID
            if (serviceOrderId) {
              childGoods.push({
                name: subItem.name,
                serviceOrderId: serviceOrderId,
              });
            }
          }
        }
        return childGoods; // 返回包含产品信息和工单ID的数组
      } else {
        this.$message({
          showClose: true,
          message: response.message,
          type: "error",
        });
      }
      return []; // 如果没有找到匹配的名称，返回空数组
    },
    viewWorkOrder(row) {
      // console.log('row::: ', row);
      let obj = {
        label: "查看工单",
        value: "/work/engineeringProject/engineer/engineerDetails/details",
        id: row.serviceOrderId
      };
      this.$router.push({
        path: resolveUrlPath(obj.value, obj.label),
        query: { GoodsId: obj.id }
      });
    },

    // 返回上一步
    goBack() {
      let item = {
        close: true,
        label: "编辑商户报单",
        value: "/work/waterProject/merchants/edit"
      };
      this.$store.commit("DEL_TAG", item);
      this.$router.go(-1);
    },
    formatDate(timestamp) {
      if (!timestamp) return '';
      const date = new Date(timestamp);
      return `${date.getFullYear()}-${(date.getMonth() + 1).toString().padStart(2, '0')}-${date.getDate().toString().padStart(2, '0')} ${date.getHours().toString().padStart(2, '0')}:${date.getMinutes().toString().padStart(2, '0')}`;
    }
  }
};
</script>

<style scoped>
.container {
  display: flex;
  flex-direction: column;
  gap: 20px;
  padding: 20px;
  min-height: 80%;
  box-sizing: border-box;
  font-family: fangsong;
  font-size: large;
}

.fixed-cards {
  display: flex;
  flex-direction: column;
  gap: 20px;
  width: 100%;
}

.card {
  width: 100%;
  max-width: 100%;
  box-sizing: border-box;
  border-radius: 10px;
  overflow: hidden;
  box-shadow: 0 2px 10px rgba(0, 0, 0, 0.1);
}

.card-content {
  padding: 20px;
}

/* 确保表格的字体与其他部分一致 */
.el-table {
  font-family: fangsong;
  font-weight: bold;
  font-size: large;
}

.el-table th,
.el-table td {
  font-family: fangsong;
  font-size: large;
}

.el-table th {
  font-family: fangsong;
  font-size: large;
}
</style>
